import React from "react";
import { Link } from "react-router-dom";
import downArrow from "../assets/downArrow.png"; // Import the arrow image

const Contact = () => {
  return (
    <>
      <div className="bg-black min-h-screen flex flex-col items-center justify-center text-center">
        {/* Title */}
        <h1 className="text-primary text-4xl font-bold mb-2">CONTACT</h1>
        <div className="flex justify-center">
          <img src={downArrow} alt="Arrow Down" className="h-7 mt-6 mb-6" />
        </div>

        {/* Contact Options */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-white">
          {/* Customer Help */}
          <div>
            <h2 className="text-primary text-xl font-bold">Customer Help</h2>
            <p className="mt-2">futcoinspot@gmail.com</p>
          </div>

          {/* Business */}
          <div>
            <h2 className="text-primary text-xl font-bold">Business</h2>
            <p className="mt-2">sales@futcoinspot.com</p>
          </div>

          {/* Social Media */}
          <div>
            <h2 className="text-primary text-xl font-bold">Social Media</h2>
            <div className="flex justify-center mt-2 space-x-4">
              <a
                href="https://x.com/futcoinspot?s=21"
                className="hover:text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-twitter">X</i>
              </a>
              <a
                href="https://discord.gg/Kvmu2sPSpd"
                className="hover:text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-discord">Discord</i>
              </a>
            </div>
          </div>
        </div>

        {/* Address */}
        <div className="mt-8 text-white">
          <h2 className="text-primary text-xl font-bold">Address</h2>
          <p className="mt-2">205 Kings Road</p>
          <p>Birmingham</p>
          <p>West Midlands</p>
          <p>England</p>
          <p>United Kingdom B11 2AA</p>
        </div>
      </div>
    </>
  );
};

export default Contact;
